import React, { Component, Fragment } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import DrawerCustom from '../../components/DrawerCustom';
import ButtonCustom from '../../components/ButtonCustom'
import CardInput from '../../components/CardInput';
import validators from '../../utils/validators';
import { formatParseReplaceSpace, formatCreditCardNumber } from '../../utils/util';
import { Field, Form } from 'react-final-form';
const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(4),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        cursor: 'pointer',
        height: '100%',
        width: '100%'
    },
});
class AddCardView extends Component {

    render() {
        const { classes, t, onCloseAddCard, card_number } = this.props
        return (
            <div>
                <DrawerCustom
                    open={this.props.open}
                    onClose={() => onCloseAddCard()}
                    title={t('add_a_card')}
                    enableBack
                >
                    <Form
                        onSubmit={this.props.onSaveCard}
                        render={({ handleSubmit, reset, submitting, pristine, values }) => (
                            <Grid xs={12} item className={classes.boxItemContent}>
                                <Field
                                    name="card_number"
                                    component={CardInput}
                                    placeholder={t('**** **** **** ****')}
                                    label={t('Card Number')}
                                    labelColor={'default'}
                                    isEdit={true}
                                    fieldParse={formatParseReplaceSpace}
                                    fieldFormat={formatCreditCardNumber}
                                    validate={validators.composeValidators(validators.required, validators.mustBeNumber)}
                                />
                                <Grid xs={12} item container justify='center' style={{marginTop:24}}>
                                    <ButtonCustom color='primary' fullWidth onClick={handleSubmit}>{t('btn_save')}</ButtonCustom>
                                </Grid>
                            </Grid>
                        )} />

                </DrawerCustom>
            </div>
        );
    }
}
export default withStyles(styles)(withTranslation()(AddCardView));